var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"back-to-top",attrs:{"id":"back-top"},on:{"click":function($event){return _vm.topFunction()}}},[_c('span',{staticClass:"ti-angle-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }